import React from "react";
import styled from "styled-components";
import { Script, ScriptStrategy } from "gatsby";

import { AVAILABLE_LANGS } from "@typings/globals";

import { langInTrustpilotFormat } from "@services/LangInTrustpilotFormat";

const widgetHeight = "24px";

interface Props {
  language: AVAILABLE_LANGS;
}

const HeroTrustpilotWidget = React.memo((props: Props): React.ReactElement => {
  const [loaded, setLoaded] = React.useState(false);
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (!loaded) return;

    (window as any).Trustpilot?.loadFromElement(ref?.current);
  }, [loaded]);

  return (
    <Container
      className="trustpilot-widget"
      data-locale={langInTrustpilotFormat(props.language)}
      data-template-id="5419b732fbfb950b10de65e5"
      data-businessunit-id="5d556e43b38e4c000162c39f"
      data-style-height={widgetHeight}
      data-style-width="fit-content"
      data-theme="light"
      data-review-languages={props.language}
      ref={ref}
    >
      <Script
        key="trustpilot"
        type="text/javascript"
        src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        strategy={ScriptStrategy.idle}
        onLoad={() => setLoaded(true)}
      />
    </Container>
  );
});

HeroTrustpilotWidget.displayName = "HeroTrustpilotWidget";

export { HeroTrustpilotWidget };

const Container = styled.div`
  position: relative;
  width: 102%;
  height: ${widgetHeight};
  margin: ${({ theme }) => `${theme.spacing.spacing_32} -1% 0`};
  padding: 0 1%;
  overflow: hidden;

  iframe {
    position: relative;
    margin-left: -32px;
  }
`;
